import { useGet } from "../hooks";
import { SRLWrapper } from "simple-react-lightbox";
import Navbar from "../navbar";
import Footer from "../footer";

const options = {
  buttons: {
    showDownloadButton: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
  },
};
function Photography() {
  const photoURL =
    "https://stetor16.dreamhosters.com/wp-json/acf/v3/photography?per_page=100";
  const [data, loading] = useGet(photoURL);

  return (
    <>
      <div className="photo__page-container ">
        <Navbar />

        {loading ? (
          "Loading Content"
        ) : (
          <div className="photo__list-contianer pt-5">
            <h1 className="photography__page-heading site__heading text-center">
              Photography
            </h1>
            <SRLWrapper options={options}>
              <ul className="photo__data-container ">
                {data.map((d) => {
                  return (
                    <li
                      key={d.id}
                      className="photo__data-box m-3 p-2 text-center"
                    >
                      <h5 className="photo__title pt-1">{d.acf.photo_title}</h5>
                      <p className="site__paragraph">{d.acf.photo_desc}</p>
                      <img
                        className="photo-box"
                        src={d.acf.photo_img.sizes.large}
                        alt="professional_photography"
                      />
                    </li>
                  );
                })}
              </ul>
            </SRLWrapper>
          </div>
        )}
        <Footer />
      </div>
    </>
  );
}
export default Photography;
